import { render, staticRenderFns } from "./PayoffDetail2Page.vue?vue&type=template&id=4e8dac0f&scoped=true&"
import script from "./PayoffDetail2Page.vue?vue&type=script&lang=ts&"
export * from "./PayoffDetail2Page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8dac0f",
  null
  
)

export default component.exports